/* tslint:disable */
/* eslint-disable */
/**
 * MVC Games
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Account } from './Account';
import {
    AccountFromJSON,
    AccountFromJSONTyped,
    AccountToJSON,
    AccountToJSONTyped,
} from './Account';
import type { PagingOutput } from './PagingOutput';
import {
    PagingOutputFromJSON,
    PagingOutputFromJSONTyped,
    PagingOutputToJSON,
    PagingOutputToJSONTyped,
} from './PagingOutput';

/**
 * 
 * @export
 * @interface ListAccountsOutputBody
 */
export interface ListAccountsOutputBody {
    /**
     * A URL to the JSON Schema for this object.
     * @type {string}
     * @memberof ListAccountsOutputBody
     */
    readonly $schema?: string;
    /**
     * List of accounts
     * @type {Array<Account>}
     * @memberof ListAccountsOutputBody
     */
    accounts: Array<Account> | null;
    /**
     * Paging information
     * @type {PagingOutput}
     * @memberof ListAccountsOutputBody
     */
    paging: PagingOutput;
}

/**
 * Check if a given object implements the ListAccountsOutputBody interface.
 */
export function instanceOfListAccountsOutputBody(value: object): value is ListAccountsOutputBody {
    if (!('accounts' in value) || value['accounts'] === undefined) return false;
    if (!('paging' in value) || value['paging'] === undefined) return false;
    return true;
}

export function ListAccountsOutputBodyFromJSON(json: any): ListAccountsOutputBody {
    return ListAccountsOutputBodyFromJSONTyped(json, false);
}

export function ListAccountsOutputBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListAccountsOutputBody {
    if (json == null) {
        return json;
    }
    return {
        
        '$schema': json['$schema'] == null ? undefined : json['$schema'],
        'accounts': (json['accounts'] == null ? null : (json['accounts'] as Array<any>).map(AccountFromJSON)),
        'paging': PagingOutputFromJSON(json['paging']),
    };
}

export function ListAccountsOutputBodyToJSON(json: any): ListAccountsOutputBody {
    return ListAccountsOutputBodyToJSONTyped(json, false);
}

export function ListAccountsOutputBodyToJSONTyped(value?: Omit<ListAccountsOutputBody, '$schema'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'accounts': (value['accounts'] == null ? null : (value['accounts'] as Array<any>).map(AccountToJSON)),
        'paging': PagingOutputToJSON(value['paging']),
    };
}

